require('jqmask');

$.validator.addMethod(
  'mobileValidation',
  (value, element) => {
    if ($(element).hasClass('required') === false) {
      return true;
    }

    if (value === undefined || value === null || value === '') {
      return false;
    }
/*
Taiwan : Here we check there is only 10 numbers.
*/
    return (/^[0-9-+()]*$/).test(value);
  }
);

$(() => {
  // MOBILE NUMBER - Mask of 9 digits
  $("[data-id='mobile']").mask('9999999999', { placeholder: '' });
});



// WEBPACK FOOTER //
// ./js/countryForm/taiwan.form.js